import $ from "jquery";
import "slick-carousel";

const init = () => {
  initSlider();
};

const initSlider = () => {
  window.onload = function () {
    console.log(document.querySelector(".flex-control-nav").innerHTML);
    $(".flex-control-nav").slick({
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      //   prevArrow:
      //     '<div class="btn-wrapper"><div class="prev-arrow"> &#8249; </div></div>',
      //   nextArrow:
      //     '<div class="btn-wrapper"><div class="next-arrow"> &#8250; </div></div>',
    });
  };
};

try {
  init();
} catch (error) {
  console.log(error);
}
